import { Category, Product } from "src/redux/apiTypes";
import getCategoriesTree from "src/utils/categories/getCategoriesTree";
import { Currency } from "src/utils/appConfig/getInitialAppConfig";
import getProductToken from "src/utils/product/getProductToken";
import { formatPrice } from "src/utils/product/formatPrice";
import { getTitleWithFilter } from "src/utils/categories/getCategorySeoMeta";

interface BreadcrumbsParams {
  categories: Category[];
  selectedCategory: Category;
  firstLevelFilterTitle: string | null;
}

export const getBreadcrumbsItems = ({ categories, selectedCategory, firstLevelFilterTitle }: BreadcrumbsParams) => {
  const baseBreadcrumbs = getCategoriesTree(categories, selectedCategory.parent_id);

  if(firstLevelFilterTitle) {
    return [
      ...baseBreadcrumbs,
      {
        id: selectedCategory.id,
        title: selectedCategory.title,
        as: `/categories/${selectedCategory.id}/`,
        to: '/categories/[category-id]',
        type: 'category',
      },
      {
        title: getTitleWithFilter(selectedCategory.title, firstLevelFilterTitle),
      },
    ];
  }

  return [
    ...baseBreadcrumbs,
    {
      title: selectedCategory.title,
    },
  ];
};



export interface AggregateOffersParams {
  currency: Currency;
  minPrice?: number;
  maxPrice?: number;
  count: number;
  products: Product[];
  baseUrl: string;
  categoryImage: string | undefined;
  categoryName: string;
}

export const getAggregateOffersMicroData = ({
  currency,
  minPrice,
  maxPrice,
  count,
  products,
  baseUrl,
  categoryImage,
  categoryName,
}: AggregateOffersParams) => {

  const offers = products.map(p => ({
    "@type": "Offer",
    "url": `${baseUrl}/products/${getProductToken(p.slug, p.ean)}`,
  }));

  return {
    "@context": "https://schema.org",
    "@type": "Product",
    ...(categoryImage && {"image": categoryImage}),
    "name": categoryName,
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": currency,
      ...(maxPrice && { "highPrice": formatPrice(maxPrice)}),
      ...(minPrice && { "lowPrice": formatPrice(minPrice)}),
      "offerCount": count,
      offers,
    },
  };
};
